module["exports"] = [
  "روستا",
  "شهر",
  "دهکده",
  "بندر",
  "دژ",
  "بندرگاه",
  "ناحیه"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/fa/address/city_suffix.js
// module id = 2901
// module chunks = 1609